import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Hero from "../components/Androidappdevelopment/Hero";
import DevelopServices from "../components/Androidappdevelopment/DevelopServices";
import Technology from "../components/Androidappdevelopment/Technology";
import Process from "../components/Androidappdevelopment/Process";
import IndustryBussinessjs from "../components/Androidappdevelopment/IndustryBussinessjs";
import Commitment from "../components/Androidappdevelopment/Commitment";
import Customers from "../components/Androidappdevelopment/Customers";
import Success from "../components/Androidappdevelopment/Success";
import PageTitle from "../components/Androidappdevelopment/PageTitle";

import '../assets/Webdevelopment.css';



const Androidappdevelopment = () => {
	return(
		<div className="App">
			<PageTitle />
	    	<Hero />
	    	<DevelopServices />
	    	<Technology />
	    	<Process />
	    	<IndustryBussinessjs />
	    	<Commitment />
	    	<Customers/>
	    	<Success />
	  </div>
	)
}

export default Androidappdevelopment;
